import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetTraffic } from 'core/Store/traffic/actions';
import { selectTraffic } from 'core/Store/traffic/selectors';
import { Traffic } from 'core/types/traffic';

let loading = false;

export default function useTrafficSelectable() {
  const showErrorNotification = useErrorNotifications();
  const [traffic, dispatch] = useSubstate(selectTraffic);

  useEffect(() => {
    if (loading || traffic.length) {
      return;
    }

    loading = true;

    client()
      .get<Traffic[]>('traffic')
      .then(response => response.data)
      .then(traffic => dispatch(new SetTraffic(traffic)))
      .catch(showErrorNotification);
  }, [dispatch, showErrorNotification, traffic]);

  return traffic;
}
